import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, ownerSelector } from "../../store/store";

import { toast } from "react-toastify";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { updateUserProfile } from "../../store/features/ownerActions";
import { Button, Input } from "../ui";

type Props = {};

const ProfileSettings = (props: Props) => {
  const { owner, currentUser } = useSelector(ownerSelector);
  const resolvedUserId =
    (typeof currentUser?.userId === "string" && currentUser.userId) ||
    (typeof (owner as any)?.userId === "string" && (owner as any).userId) ||
    "";
  const initialFirstName =
    (typeof (currentUser as any)?.firstName === "string" && (currentUser as any).firstName) ||
    (typeof (owner as any)?.userFirstName === "string" && (owner as any).userFirstName) ||
    String(owner?.name || "").trim().split(/\s+/)[0] ||
    "";
  const initialLastName =
    (typeof (currentUser as any)?.lastName === "string" && (currentUser as any).lastName) ||
    (typeof (owner as any)?.userLastName === "string" && (owner as any).userLastName) ||
    String(owner?.name || "")
      .trim()
      .split(/\s+/)
      .slice(1)
      .join(" ") ||
    "";
  const [firstName, setFirstName] = useState(initialFirstName);
  const [lastName, setLastName] = useState(initialLastName);
  const email =
    (typeof currentUser?.email === "string" && currentUser.email) || "";
  const dispatch: ThunkDispatch<RootState, undefined, Action> = useDispatch();

  React.useEffect(() => {
    setFirstName(initialFirstName);
    setLastName(initialLastName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.firstName, currentUser?.lastName]);

  const handleUpdateProfile = async () => {
    try {
      const nextFirstName = firstName.trim();
      const nextLastName = lastName.trim();
      if (!resolvedUserId) {
        toast.error("User session not loaded. Please refresh and try again.");
        return;
      }
      if (!nextFirstName || !nextLastName) {
        toast.error("First name and last name cannot be empty");
        return;
      }

      try {
        const res = await dispatch(
          updateUserProfile({
            userId: resolvedUserId,
            firstName: nextFirstName,
            lastName: nextLastName,
          }) as any
        );

        if (res.meta.requestStatus === "fulfilled") {
          toast.success("Profile updated successfully.");
        } else {
          toast.error("Error updating profile");
        }
      } catch (error: any) {
        toast.error(` ${error.message}`);
        setFirstName(initialFirstName);
        setLastName(initialLastName);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="flex h-full w-full flex-col gap-4">
      <h1 className="text-xl font-semibold text-dark-black">My Profile</h1>

      <div className="w-full max-w-4xl rounded-[8px] border border-light-grey bg-white p-5">
        <h2 className="text-md font-semibold text-dark-black">About you</h2>

        <div className="mt-5 flex flex-col gap-5 md:flex-row md:items-start">
          <div
            aria-hidden="true"
            className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full bg-[#4c2bb9] text-4xl font-semibold text-white"
          >
            {String(firstName || owner?.name || "A").trim().charAt(0).toUpperCase()}
          </div>

          <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
            <Input
              id="settings-profile-first-name"
              label="First name"
              value={firstName}
              onChange={(event) => setFirstName(event.target.value)}
              placeholder="First name"
              size="sm"
            />
            <Input
              id="settings-profile-last-name"
              label="Last name"
              value={lastName}
              onChange={(event) => setLastName(event.target.value)}
              placeholder="Last name"
              size="sm"
            />
            <Input
              id="settings-profile-email"
              label="Email"
              type="email"
              value={email}
              placeholder="Email"
              size="sm"
              disabled
              readOnly
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <Button variant="primary" size="sm" onClick={handleUpdateProfile}>
            Save Changes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfileSettings;
